import React from "react";
import AuthLayout from "../../layouts/AuthLayout/AuthLayout";
import styles from "./NoOrganizations.module.scss";

const NoOrganizations = () => {
  return (
    <AuthLayout>
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.title}>No organizations found</h1>
          <p className={styles.body}>
            We could not find any organizations linked to your account. Please
            contact the Borderly team if you believe this is a mistake or need
            access added.
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default NoOrganizations;
